import React, { useState, useEffect } from "react";

////// import images from bannerImage folder as a object
const importImages = {};

function importAll(r) {
  r.keys().forEach((key) => {
    importImages[key] = r(key);
  });
}

importAll(
  require.context("../images/bannerImages", false, /\.(png|jpe?g|svg)$/)
);

/////////////

const Banner = () => {
  /////check window size
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const isSmallScreen = windowWidth < 800;
  console.log("window",windowWidth);
  console.log(isSmallScreen);

  ////make a image list that has all the images
  const images = Object.values(importImages);

  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prevIndex) => (prevIndex + 1) % images.length);
    }, 4000); // Change image every 5 seconds (5000 milliseconds)

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div
      className="banner"
      style={{
        width: "80%",
        height: isSmallScreen ? '300px' : '600px',
        position: "relative",
        overflow: "hidden",
      }}
    >
      {images.map((image, index) => (
        <img
          key={index}
          src={image}
          alt={`Banner ${index + 1}`}
          style={{
            width: "100%",
            height: "600px",
            objectFit: "cover",
            position: "absolute",
            top: 0,
            left: 0,
            opacity: index === currentImage ? 1 : 0,
            transition: "opacity 1s ease-in-out",
          }}
        />
      ))}
    </div>
  );
};

export default Banner;
